import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { leaveViewAs } from "./app/ViewAs";
import { TooltipProvider } from "./components/ui/primitives";
import { ApiError } from "./lib/api";
import { router } from "./router";
import "./styles.css";

// A view-as ended under us (their access or ours changed): the worker has already cleared it, so
// reload into our own view rather than keep showing theirs.
const onError = (e: unknown) => {
  if (e instanceof ApiError && e.code === "view_as_ended") leaveViewAs("ended");
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RouterProvider router={router} />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
